<template>
    <div>
        <div v-if="cardList.length != 0">
            <div class="item" v-for="item in cardList" :key="item.id">
                <div class="list">
                    <div>余额：￥{{item.balance}}</div>
                    <div class="border" @click="recharge(item.series_number)">充值</div>
                </div>
                <div>卡片类型：{{item.card_type}}</div>
                <div>NO.{{item.series_number}}</div>
                <div class="recharge">
                    <div class="border" @click="cardMsg(item.series_number)">购物卡信息</div>
                    <div class="border" @click="rechargeMsg(item.series_number)">充值记录</div>
                </div>
                <div class="date">有效期至：{{item.expiry_time}}</div>
            </div>
        </div>
        <div v-else style="margin: 200px auto; text-align:center">空空如也</div>
    </div>
</template>

<script>
import { getUser, getRecharge } from "@api/user";
export default {
    data(){
        return{
            uid:'',
            cardList:[]
        }
    },

    mounted(){
        this.$dialog.loading.open("加载中");
        getUser().then(res => {
            this.uid = res.data.uid;
            this.$dialog.loading.close();
        }).catch(() => {});

        getRecharge().then(res=>{
            // 返回数据缺少 status
        }).catch((res) => {
            if(res.data.code == 0){
                this.cardList = res.data.data
            }else{
                this.$dialog.error("获取数据失败");
            }
            
            this.$dialog.loading.close();
        });
    },

    methods:{
       recharge(e){
            this.$router.push('/user/AllCard/recharge/' + e);
       },
       cardMsg(e){
            this.$router.push('/user/AllCard/cardMsg/'+ e);
       },
       rechargeMsg(e){
            this.$router.push('/user/AllCard/rechargeMsg/'+ e);
       }
    },

    watch:{
        cardList(newVal,oldVal){
            newVal.forEach((val,key) => {
                if(val.card_type == 1){
                    this.cardList[key].card_type = '购物卡';
                }else if(val.card_type == 2){
                    this.cardList[key].card_type = '礼品卡';
                }
                else if(val.card_type == 3){
                    this.cardList[key].card_type = '扶贫卡';
                }
                else if(val.card_type == 4){
                    this.cardList[key].card_type = '新阶联礼品卡';
                }
                else if(val.card_type == 5){
                    this.cardList[key].card_type = '马拉松礼品卡';
                }

                var timelist = new Date(parseInt(val.expiry_time))
                var year = timelist.getFullYear();
                var month =timelist.getMonth() + 1;
                var day = timelist.getDate();
                var times = year + "-" + month + "-" +day;
                this.cardList[key].expiry_time = times;
            });
        }
    }
}
</script>

<style scoped>
.item{
    display: flex;
    flex-direction: column;
    background-image: url('../../assets/images/kh01.png');
    background-size: 100% 100%;
    padding: 10px 20px;
    margin: 16px;
    line-height: 1.8;
    color: #fff;
    font-size: 13px;
}   

.list{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.recharge{
    display: flex;
    margin-top: 8px;
}

.recharge div:last-child{
    margin-left: 20px;
}

.border{
    background-color: #fff;
    border-radius: 4px;
    color: #000;
    padding: 0 10px;
}

.date{
    text-align: end;
    font-size: 13px;
}
</style>